import React from 'react'
import styled from 'styled-components'

export type OverlayProps = {
  children: React.ReactNode,
  isOpen: boolean
}

const OverLayStyle = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, .5);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 1000;
  overscroll-behavior: contain;
  overflow-y: scroll;
  touch-action: auto;
`

export const StyledOverlay: React.FC<OverlayProps> = (props: OverlayProps) => {
  return (
    props.isOpen &&
    <OverLayStyle>
      {props.children}
    </OverLayStyle>
  )
}
